module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Flums-ec66d4af492c8ceadcae4b7740d49085.png";